import { ResponsiveTable } from "../mobile/ResponsiveTable";
/** 手机记录列表复用原有数据、勾选与业务操作；普通记录按字段卡片呈现，交互表头和对比矩阵保留横向浏览。 */
import React from "react";
import { fmtDT } from "../../lib/date";

export const RESULT_STYLE = {
  valid: { zh: "有效", en: "Valid", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  tampered: { zh: "篡改", en: "Tampered", cls: "bg-red-50 text-red-700 border-red-200" },
  not_found: { zh: "不存在", en: "Not found", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  bad_format: { zh: "格式错", en: "Bad format", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const ResultBadge = ({ r, zh, tid }) => {
  const s = RESULT_STYLE[r] || RESULT_STYLE.bad_format;
  return <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded border ${s.cls}`} data-testid={tid}>{zh ? s.zh : s.en}</span>;
};

export const money = (n) => (n == null ? "—" : "$" + Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

/* 核验记录行（全局 / 单客户共用） */
export function VerifyRows({ rows, zh, tid, showClient }) {
  if (!rows?.length) return <p className="text-xs text-slate-400 py-3 text-center" data-testid={`${tid}-empty`}>{zh ? "暂无核验记录" : "No verification records yet"}</p>;
  return (
    <div className="overflow-x-auto">
      <ResponsiveTable className="w-full text-xs">
        <thead><tr className="text-[10px] uppercase tracking-wide text-slate-400 text-left">
          <th className="py-1 pr-2 font-medium">{zh ? "时间" : "Time"}</th><th className="py-1 pr-2 font-medium">{zh ? "结果" : "Result"}</th><th className="py-1 pr-2 font-medium">{zh ? "防伪码" : "Code"}</th>
          {showClient && <th className="py-1 pr-2 font-medium">{zh ? "客户 / 回执" : "Client / Receipt"}</th>}<th className="py-1 pr-2 font-medium">IP</th><th className="py-1 font-medium hidden md:table-cell">{zh ? "设备" : "Device"}</th>
        </tr></thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id || i} className={`border-t border-slate-100 ${r.result === "tampered" ? "bg-red-50/60" : ""}`} data-testid={`${tid}-row-${i}`} data-result={r.result} data-ip={r.ip}>
              <td className="py-1.5 pr-2 whitespace-nowrap text-slate-600">{fmtDT(r.at)}</td>
              <td className="py-1.5 pr-2"><ResultBadge r={r.result} zh={zh} /></td>
              <td className="py-1.5 pr-2 font-mono text-slate-700">{r.code || "—"}</td>
              {showClient && <td className="py-1.5 pr-2 text-slate-600 max-w-[180px] truncate">{r.clientName || "—"}{r.receiptNo ? ` · ${r.receiptNo}` : ""}{r.amount != null ? ` · ${money(r.amount)}` : ""}</td>}
              <td className="py-1.5 pr-2 font-mono text-slate-500">{r.ip || "—"}</td>
              <td className="py-1.5 text-slate-400 hidden md:table-cell max-w-[220px] truncate" title={r.ua}>{r.ua || "—"}</td>
            </tr>
          ))}
        </tbody>
      </ResponsiveTable>
    </div>
  );
}

/* 可疑来源：同 IP 60 分钟内 ≥N 次失败 / 出现篡改 */
export function SuspiciousList({ items, zh, tid, rule }) {
  if (!items?.length) return <p className="text-xs text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2" data-testid={`${tid}-none`}>{zh ? `未发现可疑核验（规则：同一 IP ${rule?.minutes || 60} 分钟内 ≥${rule?.n || 3} 次失败，或出现篡改）。` : `No suspicious activity (rule: same IP ≥${rule?.n || 3} failures within ${rule?.minutes || 60} min, or any tampered hit).`}</p>;
  return (
    <ul className="space-y-1.5">
      {items.map((s, i) => (
        <li key={s.ip} className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs" data-testid={`${tid}-${i}`} data-ip={s.ip} data-tampered={s.tampered} data-burst={s.burst}>
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-mono font-semibold text-red-800">{s.ip}</span>
            {s.tampered > 0 && <span className="px-1.5 py-0.5 rounded bg-red-600 text-white text-[10px] font-bold">{zh ? `篡改 ×${s.tampered}` : `Tampered ×${s.tampered}`}</span>}
            {s.reasons?.includes("burst") && <span className="px-1.5 py-0.5 rounded bg-amber-500 text-white text-[10px] font-bold">{zh ? `${s.burst} 次失败 / 1 小时` : `${s.burst} failures / 1h`}</span>}
            <span className="text-slate-500">{zh ? "共失败" : "failures"} {s.failures} · {fmtDT(s.firstAt)} → {fmtDT(s.lastAt)}</span>
          </div>
          <div className="text-[11px] text-slate-500 mt-1 truncate" title={s.ua}>{zh ? "尝试的码" : "Codes"}: <span className="font-mono">{(s.codes || []).join(", ") || "—"}</span>{s.ua ? ` · ${s.ua}` : ""}</div>
        </li>
      ))}
    </ul>
  );
}
